module.exports = __webpack_public_path__ + "static/media/delete-icon.7f519469.svg";